import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardLayeredStandard as OCardLayeredStandardComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardLayeredStandardConfig = {
  emptyLabel: 'OCardLayeredStandard',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-standard-layered`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardLayeredStandard = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-standard-layered-comp"
      data-component-name="o-card-standard-layered"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardLayeredStandardConfig} {...props}>
        <OCardLayeredStandardComp {...props} />
      </EditableComponent>
    </div>
  );
};
